// import Resoursemanagement1 from './../resourse/Resourse.vue'
// import StoreModule1 from './../storemodule/StoreModule.vue'
// import classlist from './../classlist/classlist.vue'

export default {
  name: 'instructor',
  data() {
    return {
      //搜索用户名
      username: '',
      //搜索用户电话
      userphone: '',
      // 每页请求的数目
      length: 15,
      dialogFlag1: false,
      dialogFlag2: false,
      dialogFlag3: false,
      dialogFlag4: false,
      obj1: {
        name: '',
        idcard: '',
        company: '',
        phone: '',
        email: '',
        desc: '',
        img: '',
        enabled: '',
        password: ''
      },
      obj3: {
        name: '',
        idcard: '',
        company: '',
        phone: '',
        email: '',
        desc: '',
        img: '',
        enabled: '',
        password: ''
      },
      obj2: {
        name: '',
        idcard: '',
        company: '',
        phone: '',
        email: '',
        desc: '',
        img: '',
        enabled: '',
        password: ''
      },
      addinstructor:
        [
          {
            name: '',
            image: '',
            idcard: '',
            company: '',
            phone: '',
            email: '',
            delog: '',
            password: '',
            enabled: ''
          }
        ],
      totalinstructs:
      {
        nameFuck: []
      },
      name: '',
      image: '',
      idcard: '',
      company: '',
      phone: '',
      email: '',
      delog: '',
      password: '',
      enabled: '',
      total: 0,
      currentPage: 1,
    }
  },
  methods: {
    // 设置修改时对象的替换
    chakan(item) {
      this.obj1 = item;
    },
    xiugai(item) {
      this.name = item.name;
      this.image = item.image;
      this.idcard = item.idcard;
      this.company = item.company;
      this.phone = item.phone;
      this.email = item.email;
      this.delog = item.desc;
      this.password = item.password;
      this.enabled = item.enabled;
      this.obj2 = item;
    },
    shanchu(item) {
      this.obj3 = item;
      this.$confirm('此操作将永久删除辅导员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteinstructor(item.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //添加辅导员
    addinstructors() {
      if (this.addinstructor[0].name == '' || this.addinstructor[0].name.length > 18) {
        this.$message.error('名字不规范');
        return false
      } else if (this.addinstructor[0].idcard == '' || this.addinstructor[0].idcard.length > 18) {
        this.$message.error('身份证号不规范');
        return false
      } else if (this.addinstructor[0].company == '') {
        this.$message.error('所在单位不规范');
        return false
      } else if (this.addinstructor[0].phone == '' || this.addinstructor[0].phone.length > 18) {
        this.$message.error('手机号码不规范');
        return false
      } else if (this.addinstructor[0].email == '') {
        this.$message.error('邮箱地址不规范');
        return false
      } else if (this.addinstructor[0].delog == '') {
        this.$message.error('介绍不规范');
        return false
      } else if (this.addinstructor[0].enabled == '') {
        this.$message.error('状态不规范');
        return false
      }
      this.$post('instructor/create',
        {
          name: this.addinstructor[0].name,
          idcard: this.addinstructor[0].idcard,
          company: this.addinstructor[0].company,
          phone: this.addinstructor[0].phone,
          email: this.addinstructor[0].email,
          desc: this.addinstructor[0].delog,
          img: this.addinstructor[0].image,
          enabled: this.addinstructor[0].enabled,
          password: this.addinstructor[0].idcard,
          shop_id: this.$store.state.store.id,
          token: this.$store.state.authority_management
        }).then(res => {
          if (res.data.status == 'success') {
            this.dialogFlag4 = false;
            this.$message({
              message: '添加成功',
              type: 'success'
            });

            this.getinstructors();
            this.addinstructor[0].name = '';
            this.addinstructor[0].image = '';
            this.addinstructor[0].idcard = '';
            this.addinstructor[0].company = '';
            this.addinstructor[0].phone = '';
            this.addinstructor[0].email = '';
            this.addinstructor[0].delog = '';
            this.addinstructor[0].password = '';
            this.addinstructor[0].enabled = null;
          }
          if (res.data.status == 'fail') {
            this.dialogFlag4 = false;
            this.$message({
              message: res.data.errorMsg,
              type: 'error'
            });
          }
        });
    },
    //添加辅导员时的提示
    addinstructordialog(){
      this.dialogFlag4 = true;
      this.$alert('辅导员的初始密码默认为其身份证号码', '备注', {
        confirmButtonText: '确定',
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      });
      // this.$message({
      //   message: '辅导员初始密码默认为其身份证号码'
      // });

    },
    //查找辅导员
    getinstructors: function () {
      const num = (this.currentPage - 1) * this.length;
      //查询全部发送给后台的数据
      let data = {
        offset: num,
        length: 15,
        token: this.$store.state.authority_management,
        shop_id: this.$store.state.store.id
      }
      //查询全部时候的请求
      this.$post('instructor/search', data)
        .then(res => {
          this.total = res.data.result.total;
          for (let obj of res.data.result.data) {
            if (obj.enabled == 0) {
              obj.enabled = '不可用';
            }
            if (obj.enabled == 1) {
              obj.enabled = '可用';
            }
          }
          this.totalinstructs = {};
          this.totalinstructs['nameFuck' + this.currentPage] = [...res.data.result.data];
        })
    },
    //修改辅导员
    updateinstructor: function (id, name, idcard, company, phone, email, desc, img, enabled, password) {
      if (name == '' || name.length > 18) {
        this.$message.error('名字不规范');
        return
      } else if (idcard == '' || idcard.length > 18) {
        this.$message.error('身份证号不规范');
        return
      } else if (company == '') {
        this.$message.error('所在单位不规范');
        return
      } else if (phone == '' || phone.length > 11) {
        this.$message.error('手机号码不规范');
        return
      } else if (email == '') {
        this.$message.error('邮箱地址不规范');
        return
      } else if (desc == '') {
        this.$message.error('介绍不规范');
        return
      } else if (enabled == '') {
        this.$message.error('状态不规范');
        return
      } else if (password == '') {
        this.$message.error('密码不规范');
        return
      }
      if (enabled == '可用') {
        enabled = 1;
      }
      if (enabled == '不可用') {
        enabled = 0;
      }
      this.$post('instructor/edit', {
        id: id,
        token: this.$store.state.authority_management,
        name: name,
        idcard: idcard,
        company: company,
        phone: phone,
        email: email,
        desc: desc,
        img: img,
        enabled: enabled,
        password: password
      })
        .then(res => {
          if (res.data.status == 'success') {
            this.dialogFlag2 = false;
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.getinstructors();
          }
        })
    },
    // 删除辅导员
    deleteinstructor: function (id) {

      this.$post('instructor/delete', { id: id, token: this.$store.state.authority_management })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            // this.totalinstructs={};
            this.getinstructors();
          }
        })
    },
    handleClose(done) {
      //  this.$confirm('确认关闭？一经关闭数据不可恢复')
      //   .then(_ => {
      done();
      this.obj2.name = this.name;
      this.obj2.image = this.image;
      this.obj2.idcard = this.idcard;
      this.obj2.company = this.company;
      this.obj2.phone = this.phone;
      this.obj2.email = this.email;
      this.obj2.desc = this.delog;
      this.obj2.password = this.password;
      this.obj2.enabled = this.enabled;
      // })
      // .catch(_ => {});
    },
    getStudentPage(currentPage) {
      this.currentPage = currentPage;
      // console.log(this.currentPage)
      this.getinstructors();
    },
    handleClosetianjia(done) {
      done();
      let obj = {}
      obj.name = ''
      obj.image = ''
      obj.idcard = ''
      obj.company = ''
      obj.phone = ''
      obj.email = ''
      obj.delog = ''
      obj.password = ''
      obj.enabled = null
      this.addinstructor[0] = [];
      this.addinstructor.push(obj);
    },
    //改变每页请求的数目
    handleSizeChange(val) {
      this.length = val;
      this.getinstructors();
    },
    //搜索辅导员
    confirmSearch() {
      const num = (this.currentPage - 1) * this.length;
      //发送给后台的数据
      let data = {
        token: this.$store.state.authority_management,
        name: this.username,
        phone: this.userphone,
        offset: num,
        length: 15,
        shop_id: this.$store.state.store.id
      }
      this.$post('instructor/search', data).then(res => {
        for (let obj of res.data.result.data) {
          if (obj.enabled == 0) {
            obj.enabled = '不可用';
          }
          if (obj.enabled == 1) {
            obj.enabled = '可用';
          }
        }
        this.total = res.data.result.total;
        this.totalinstructs['nameFuck' + this.currentPage] = [...res.data.result.data];

      })
    },
    read() {
      // console.log(this.addinstructor)
    }
  },
  mounted() {
    this.getinstructors();
  }
}